 <template>
  <div>
    <!-- Activities table -->
    <div class="card"
         qid="third-parties-section"
         v-if="isGranted([permissions.MEASURE_VIEW, permissions.MEASURE_VIEW_OWN], measure)"
    >
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <h5 class="float-left">{{ $t('maintenance.measures.third_parties_title') }}</h5>
          </div>
          <div class="col-sm-6 text-right">
            <button class="btn btn-success ml-3 pl-3 pr-3"
                    @click="showEditSModal()"
                    qid="measure-system-create-button"
                    v-if="isGranted([permissions.MEASURE_EDIT, permissions.MEASURE_EDIT_OWN], measure) && (!getClient.parent || (getClient.parent && measure.partition))"
            >
              <font-awesome-icon icon="plus"/> {{ $t('projects.third_party.create_button') }}
            </button>
          </div>
        </div>

        <table class="table table-responsive-md">
          <thead>
          <tr>
            <th scope="col">
              {{ $t('table.name') }}
            </th>
            <th scope="col">
              {{ $t('activities.table.owners') }}
            </th>
            <th scope="col">
              {{ $t('activities.table.tags') }}
            </th>
            <th width="130"></th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="(object, index) in sTableItems"
                :id="'table-row-' + index"
            >
              <td>
                <router-link
                    :to="{ name: 'contracts.view', params: { slug: object.third_party.slug }}"
                    qid="s-view-page-link"
                >
                  {{ object.third_party.name }}
                </router-link>
              </td>
              <td>
                <span class="mr-1" v-for="user in getReducedUsers(object.third_party.users)">
                  <span qid="profile-photo">
                    <Avatar :object="user" size="xs"></Avatar>
                  </span>
                </span>
                <button v-if="object.third_party.users.length > 3"
                        class="badge badge-info mr-1 rounded-circle"
                        @click="openUsersModal(object.third_party)"
                >
                  + {{ object.third_party.users.length - 3 }}
                </button>
              </td>
              <td>
                <span class="mr-1" v-for="tag in getReducedTags(object.third_party.tags_translated)" qid="p-tags-list">
                  <span class="badge badge-info mb-1" :title="tag.name_translated">
                    {{ tag.name_translated | truncate(35) }}
                  </span>
                </span>
                <button v-if="object.third_party.tags_translated.length > 3"
                        class="badge badge-info mb-1"
                        @click="openTagsModal(object.third_party)"
                >
                  + {{ object.third_party.tags_translated.length - 3 }}
                </button>
              </td>
              <td align="right">
                <button class="btn btn-delete"
                        qid="delete-measure-modal"
                        @click="showSConfirmDeleteModal(object)"
                        v-if="isGranted([permissions.MEASURE_EDIT, permissions.MEASURE_EDIT_OWN], measure) && (!getClient.parent || (getClient.parent && measure.partition))"
                >
                  <font-awesome-icon icon="trash-alt" />
                </button>
              </td>
            </tr>
            <tr v-if="!sLoading && !sTableItems.length" qid="no-results-row" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>


    <!-- Delete system modal template -->
    <b-modal ref="delete-ac" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-ac-title">
          {{ $t('activities.system.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('activities.system.delete.description') }}
        <span v-if="itemToDelete">{{ itemToDelete.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('activities.system.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideSConfirmDeleteModal"
                  qid="delete-ac-cancel-button"
        >
          {{ $t('activities.system.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteS(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-ac-submit-button"
        >
          {{ $t('activities.system.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Add third party modal -->
    <b-modal ref="edit-system"
             hide-footer
             @hide="hideEditSModal"
             size="xl"
    >
      <div class="d-block text-center">
        <h4 qid="update-tp-title">
          {{ $t('projects.third_party.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-p-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="addItemsFormSubmit" qid="create-p-form">
        <div>
          <div class="row">
            <div class="col">
              <b-form-group>
                <label qid="edit-lb-category-label">
                  {{ $t('projects.third_party.create.add_label') }}
                </label>
                <div>
                  <b-form-input
                    type="text"
                    v-model="keywordValue"
                    @click="showSelectionTable = true"
                    qid="search-do-input"
                    v-on:input="debounceInput"
                    :placeholder="$t('projects.third_party.create.search_placeholder')"
                  ></b-form-input>
                </div>
              </b-form-group>
              <div>
                <label class="float-right cursor-pointer ml-3 pt-2"
                       @click="unselectAll"
                       qid="system-unselect-button"
                >
                  {{ $t('system.unselect_all') }}
                </label>
                <label class="float-right cursor-pointer pt-2"
                       @click="selectAll"
                       qid="system-select-button"
                >
                  {{ $t('system.select_all') }}
                </label>
              </div>
              <br>
              <div class="form-control scrollable-height-400"
                   qid="tp-source-data-objects"
              >
                <div>
                  <table class="table table-responsive-md table-sm">
                    <thead>
                    <tr>
                      <th scope="col">
                        {{ $t('table.name') }}
                      </th>
                      <th scope="col">
                        {{ $t('activities.table.tags') }}
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in DOItems"
                          @click="selectDataObject(index, item)"
                          class="cursor-pointer text-bold"
                          :class="{'table-info': item.selected}"
                      >
                        <td v-if="item">
                          {{ item.name }}
                        </td>
                        <td v-if="item">
                          <span class="mr-1" v-for="tag in getReducedTags(item.tags_translated)" qid="p-tags-list">
                            <span class="badge badge-info mb-1" :title="tag.name_translated">
                              {{tag.name_translated | truncate(35)}}
                            </span>
                          </span>
                          <span v-if="item.tags_translated.length > 3"
                                  class="badge badge-info mb-1"
                                  @click="openTagsModal(item, $event)"
                          >
                            + {{ item.tags_translated.length - 3 }}
                          </span>
                        </td>
                      </tr>
                      <tr v-if="!sLoading && !DOItems.length" qid="no-results-row" class="text-center">
                        <td colspan="10">
                          <h5 class="mt-3">
                            {{ $t('system.no_results') }}
                          </h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="text-muted mt-2 mb-3">
                {{ $t('projects.create.selected_items_tip') }}
              </div>
            </div>
            <div class="col-1">
              <b-button class="mt-300 btn-block"
                        variant="success"
                        @click="addData"
                        size="sm"
                        qid="system-select-button"
              >
                {{ $t('system.add') }} >
              </b-button>
            </div>
            <div class="col">
              <b-form-group>
                <label qid="edit-s-data-label">
                  {{ $t('projects.third_party.create.select_item_label') }}
                </label>
                <div>
                  <b-form-input
                    type="text"
                    v-model="keywordFilterValue"
                    qid="search-do-input"
                    v-on:input="filterSelectedData"
                    :placeholder="$t('projects.third_party.create.filter_placeholder')"
                  ></b-form-input>
                </div>
              </b-form-group>

              <br>
              <div class="form-control scrollable-height-400 mt-3" qid="tp-source-data-objects">
                <div>
                  <table class="table table-responsive-md table-sm">
                    <thead>
                    <tr>
                      <th scope="col">
                        {{ $t('table.name') }}
                      </th>
                      <th scope="col">
                        {{ $t('activities.table.tags') }}
                      </th>
                      <th width="40"></th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(itemDO, index) in allDataObjectsFiltered"
                          class="cursor-pointer text-bold"
                      >
                        <td>
                          {{ itemDO.name }}
                        </td>
                        <td>
                          <span class="mr-1" v-for="tag in getReducedTags(itemDO.tags_translated)" qid="p-tags-list">
                            <span class="badge badge-info mb-1" :title="tag.name_translated">
                              {{tag.name_translated | truncate(35)}}
                            </span>
                          </span>
                          <span v-if="itemDO.tags_translated && itemDO.tags_translated.length > 3"
                                class="badge badge-info mb-1"
                                @click="openTagsModal(itemDO, $event)"
                          >
                            + {{ itemDO.tags_translated.length - 3 }}
                          </span>
                        </td>
                        <td>
                          <span class="pt-2 pb-2 pl-2 pr-2">
                            <font-awesome-icon
                                icon="times"
                                size="sm"
                                @click="removeDataItem(itemDO)"
                                qid="tp-source-data-object-remove"
                                v-if="itemDO.new_item"
                            />
                          </span>
                        </td>
                      </tr>
                      <tr v-for="(itemDO, index) in sTableItems"
                          class="cursor-pointer text-bold table-secondary"
                      >
                        <td>
                          {{ itemDO.third_party.name }}
                        </td>
                        <td>
                          <span class="mr-1" v-for="tag in getReducedTags(itemDO.third_party.tags_translated)" qid="p-tags-list">
                            <span class="badge badge-info mb-1" :title="tag.name_translated">
                              {{tag.name_translated | truncate(35)}}
                            </span>
                          </span>
                          <span v-if="itemDO.third_party.tags_translated && itemDO.third_party.tags_translated.length > 3"
                                  class="badge badge-info mb-1"
                                  @click="openTagsModal(itemDO.third_party, $event)"
                          >
                            + {{ itemDO.third_party.tags_translated.length - 3 }}
                          </span>
                        </td>
                        <td></td>
                      </tr>
                      <tr v-if="!sTableItems.length && !allDataObjectsFiltered.length" qid="no-results-row" class="text-center">
                        <td colspan="10">
                          <h5 class="mt-3">
                            {{ $t('system.no_results') }}
                          </h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditSModal"
                    qid="create-p-cancel-button"
          >
            {{ $t('systems.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    :disabled="buttonDisabled"
                    variant="success"
                    qid="create-p-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('projects.activity.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <ShowMoreModal
        :items="selectedItem.users"
        :show="showUsersModal"
        @closeViewModal="closeUsersModal"
        type="users"
    ></ShowMoreModal>

    <ShowMoreModal
        :items="selectedItem.tags_translated"
        :show="showTagsModal"
        @closeViewModal="closeTagsModal"
        type="tags"
    ></ShowMoreModal>

  </div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import ShowMoreModal from '@/components/ShowMoreModal.vue';

  export default {
    name: 'ActivitiesTable',
    data: function() {
      return {
        sForm: {
          items: []
        },

        measure: {},

        // Systems
        sTableItems: [],
        selectedS: [],
        viewSModal: false,
        selectedSSort: '',
        selectedSDirection: '',
        sItems: [],
        sLoading: true,
        selectedItem: {},

        // Data objects
        allDataObjects: [],
        allDataObjectsFiltered: [],
        dataObjects: [],
        systemDataObjects: [],
        newDataObjects: [],
        DOItems: [],
        selectedDataObjects: [],
        availableDataObjects: [],

        error: '',
        loadingItems: false,
        itemToDelete: {},
        itemObject: {},
        selectedP: [],
        selectedUsers: [],
        users: [],
        radioOptions: [
          {text: this.$t('system.yes'), value: 1},
          {text: this.$t('system.no'), value: 0}
        ],
        buttonDisabled: false,
        keywordValue: '',
        keywordFilterValue: '',
        showSelectionTable: false,
        selectedFiles: [],
        inputLink: '',
        showDocuments: false,
        filteredDataObjects: [],
        showUsersModal: false,
        showTagsModal: false,
        open_tasks: [],
        showListOfTasks: false
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      }
    },
    components: {
      Avatar,
      ShowMoreModal
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
      },
      object: function (value) {
        this.measure = value;
      }
    },
    methods: {
      debounceInput: _.debounce(function() {
        this.loadDO(this.keywordValue)
      }, 400),
      resetFile() {
        let imagefile = document.querySelector('#file');
        imagefile.value = '';
      },
      onFileChange() {
        let files = document.querySelector('#file');
        // in order for v-for to re render, we need to set array to empty
        this.selectedFiles = [];
        // And then push item by item into that array
        for (var i = 0; i < files.files.length; i++) {
          this.selectedFiles.push(files.files[i])
        }
      },
      handleLink() {
        // If there's a link in input, add it to links array
        if (this.inputLink !== '') {
          if (!this.inputLink.startsWith('http')) {
            this.inputLink = 'http://' + this.inputLink
          }
          this.sForm.links.push(this.inputLink)
          // Reset link input form
          this.inputLink = ''
        }
      },
      removeLinkItem(index) {
        // Remove link item from the links array
        this.sForm.links.splice(index, 1);
      },
      addData() {
        let self = this;
        _.forEach(this.DOItems, function (item) {
          if (item.selected) {
            self.updateDOList(item)
          }
        })
        this.keywordValue = '';
        this.loadDO()
      },
      filterSelectedData() {
        let self = this;
        this.allDataObjectsFiltered = [];
        if (self.keywordFilterValue) {
          _.forEach(this.allDataObjects, function (item) {
            if (
              item.name.toLowerCase().indexOf(self.keywordFilterValue.toLowerCase()) !== -1 ||
              (item.category && item.category.toLowerCase().indexOf(self.keywordFilterValue.toLowerCase()) !== -1) ||
              (item.classification && item.classification.toLowerCase().indexOf(self.keywordFilterValue.toLowerCase()) !== -1)
            ) {
              self.allDataObjectsFiltered.push(item)
            }
          })
        } else {
          this.allDataObjectsFiltered = _.cloneDeep(this.allDataObjects);
        }
      },
      resetFields() {
        this.selectedRC = null
        this.selectedP = null
      },
      showDataObjectsModal(object, classification) {
        let self = this;
        this.selectedS = object

        if (!object) {
          this.availableDataObjects = [];
        }

        _.forEach(object.data_objects, function (item) {
          if (item.classification == classification) {
            self.filteredDataObjects.push(item)
          }
        })

        this.$refs['view-data-objects'].show()
      },
      hideDataObjectsModal() {
        this.selectedS = {}
        this.filteredDataObjects = []
        this.$refs['view-data-objects'].hide()
      },
      showEditModal(object) {
        let self = this;
        this.error = '';
        this.loadUsers();

        if (object.users && object.users.length) {
          self.selectedUsers = [];
          _.forEach(object.users, function (user) {
              self.selectedUsers.push(user)
          })
        }

        this.selectedS = object
        this.$refs['edit-item'].show()
      },
      hideEditModal() {
        this.selectedS = {}
        this.selectedUsers = [],
        this.$refs['edit-item'].hide()
      },
      editFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        let responsibles = []
        if (this.selectedUsers && this.selectedUsers.length) {
          for (var i = 0; i < this.selectedUsers.length; i++) {
            responsibles.push(this.selectedUsers[i].id);
          }
        }

        piincHttp.put('measures/' + this.$route.params.slug + '/third-parties/' + this.selectedS.id, {
          users: responsibles
        }).then(function(response) {
          self.hideEditModal();
          self.loadThirdParties();
          // Emit event to parent component to update newest validation
          self.$emit('reloadContent', response.data);
          self.$toastr('success', self.$t('projects.third_party.update.success'))
          self.buttonDisabled = false;
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.users) {
              self.error += ' ' + error.data.errors.users[0]
            }
          }
        })
      },
      showSConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.showListOfTasks = false
        this.$refs['delete-ac'].show()
      },
      hideSConfirmDeleteModal() {
        this.itemToDelete = {}
        this.$refs['delete-ac'].hide()
      },
      openTagsModal(object, evt) {
        this.selectedItem = object
        this.showTagsModal = true
      },
      closeTagsModal() {
        this.selectedItem = {}
        this.showTagsModal = false
      },
      openUsersModal(object) {
        this.selectedItem = object
        this.showUsersModal = true
      },
      closeUsersModal() {
        this.selectedItem = {}
        this.showUsersModal = false
      },
      getReducedTags(tags) {
        let reducedTags = []
        if (tags.length > 3) {
          reducedTags = _.cloneDeep(tags);
          reducedTags = reducedTags.slice(0, 3);
        } else {
          reducedTags = tags;
        }
        return reducedTags;
      },
      getReducedUsers(users, type) {
        let reducedUsers = []

        if (type == 'owner') {
          _.forEach(users, function (item) {
            if (item.owner) {
              reducedUsers.push(item)
            }
          })
        } else if (type == 'member') {
          _.forEach(users, function (item) {
            if (!item.owner) {
              reducedUsers.push(item)
            }
          })
        } else {
          if (users.length > 3) {
            reducedUsers = _.cloneDeep(users);
            reducedUsers = reducedUsers.slice(0, 3);
          } else {
            reducedUsers = users;
          }
        }

        return reducedUsers;
      },
      showDataObjects(object) {
        this.availableDataObjects = []
        if (object && object.data_objects && object.data_objects.length) {
          this.availableDataObjects = object.data_objects;
        }
      },
      hideDataObjects() {
        this.availableDataObjects = []
      },
      handleDO(index, item) {
        // Toggle related/not related property
        item.related = item.related ? false : true;
        this.$set(this.allDataObjects, index, item)
      },
      selectDataObject(index, item) {
        // Toggle related/not related property
        item.selected = item.selected ? false : true;
        this.$set(this.DOItems, index, item)
      },
      selectAll() {
        let newDataObjectsArray = []
        let self = this;
        _.forEach(this.DOItems, function (item) {
          item.selected = true;
          newDataObjectsArray.push(item)
        })
        this.DOItems = newDataObjectsArray;
      },
      unselectAll() {
        let newDataObjectsArray = []
        let self = this;
        _.forEach(this.DOItems, function (item) {
          item.selected = false;
          newDataObjectsArray.push(item)
        })
        this.DOItems = newDataObjectsArray;
      },
      relateAll() {
        let newDataObjectsArray = []
        _.forEach(this.allDataObjects, function (item) {
          item.related = true;
          newDataObjectsArray.push(item)
        })
        // make cloned array to avoid double actions on arrays
        this.allDataObjects = _.cloneDeep(newDataObjectsArray);
        this.allDataObjectsFiltered = _.cloneDeep(newDataObjectsArray);
      },
      unrelateAll() {
        let newDataObjectsArray = []
        _.forEach(this.allDataObjects, function (item) {
          item.related = false;
          newDataObjectsArray.push(item)
        })
        // make cloned array to avoid double actions on arrays
        this.allDataObjects = _.cloneDeep(newDataObjectsArray);
        this.allDataObjectsFiltered = _.cloneDeep(newDataObjectsArray);
      },
      updateDOList(selectedOption) {
        let self = this;
        let inArray = false;
        _.forEach(this.allDataObjects, function (item, index) {
          if (item.id == selectedOption.id) {
            // if item is already in array
            item.related = true;
            self.$set(self.allDataObjects, index, item)
            inArray = true;
            self.allDataObjectsFiltered = _.cloneDeep(self.allDataObjects);
          }
        })
        if (!inArray) {
          // If not in array, push it in array as related
          selectedOption.related = true;
          selectedOption.new_item = true;
          self.allDataObjects.push(selectedOption)
          self.allDataObjectsFiltered = _.cloneDeep(self.allDataObjects);
        }
      },
      removeDataItem(item) {
        // find indexes for both arrays
        let filteredIndex = _.findIndex(this.allDataObjectsFiltered, function(o) { return o.id == item.id; });
        let itemIndex = _.findIndex(this.allDataObjects, function(o) { return o.id == item.id; });

        // Remove item from data objects arrays
        this.allDataObjectsFiltered.splice(filteredIndex, 1);
        this.allDataObjects.splice(itemIndex, 1);

        this.loadDO()
      },
      showEditSModal(object) {
        let self = this;
        let inArray = false;

        this.loadDO();

        this.allDataObjectsFiltered = _.cloneDeep(this.allDataObjects);
        this.$refs['edit-system'].show()
      },
      hideEditSModal() {
        this.selectedDataObjects = []
        this.keywordValue = ''
        this.keywordFilterValue = ''
        this.showSelectionTable = false
        this.allDataObjects = []
        this.systemRoleInput = ''
        this.error = ''
        this.$refs['edit-system'].hide()
      },
      confirmDeleteS(object) {
        let self = this;
        piincHttp.delete('measures/' + this.$route.params.slug + '/third-parties/' + object.id).then(function() {
          self.hideSConfirmDeleteModal();
          self.loadThirdParties();
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('projects.third_party.delete.success'))
        }, function() {});
      },

      addItemsFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        self.sForm.items = []

        _.forEach(this.allDataObjects, function (item) {
          self.sForm.items.push(item.id)
        })

        if (self.sForm.items && self.sForm.items.length) {
          piincHttp.post('/measures/' + this.$route.params.slug + '/third-parties', {
            third_parties: this.sForm.items
          }).then(function(response) {
            self.$toastr('success', self.$t('projects.third_party.create.success'))
            self.hideEditSModal();
            self.loadThirdParties();
            self.buttonDisabled = false;
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
              if (error.data.errors.process_id) {
                self.error += ' ' + error.data.errors.process_id[0]
              }
            }
          })
        } else {
          this.error = this.$t('projects.third_party.create.required')
          self.buttonDisabled = false;
        }

      },
      loadThirdParties() {
        let self = this;
        self.sTableItems = []
        piincHttp.get('measures/' + this.$route.params.slug + '/third-parties', { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.sTableItems = response.data
          self.sLoading = false;
        }, function() {});
      },
      loadDO(query) {
        let self = this;
        self.DOItems = []
        piincHttp.get('third-parties', { params:
          {
            client: this.getClient.slug,
            per_page: 100,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          let results = response.data.items
          _.forEach(results, function (item) {
            if (_.findIndex(self.sTableItems, function(o) { return o.third_party.id == item.id }) == -1 && _.findIndex(self.allDataObjects, function(o) { return o.id == item.id }) == -1) {
              self.DOItems.push(item)
            }
          })
        }, function() {});
      },
    },
    created () {
      this.measure = this.object;
      if (this.getClient && this.getClient.slug) {
      }
      // Table items
      this.loadThirdParties();
    }
  }
</script>
